module.exports = __webpack_public_path__ + "img/carpet-scheme.b4cce51d.png";